import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'
import { getFileName } from 'utils/documents'

type Payload = {
  documentSourceId: number
  url: string
  name: string
}

const requestChangeDocumentName = (payload: Payload) => async (dispatch, getState) => {
  const { documentSourceId, url, name } = payload

  try {
    const result = await apiAction('RenameFile', {
      documentSourceId,
      url,
      name,
    })

    return result.NewName
  } catch (error) {
    if (error.code === 509) {
      const state = getState()

      try {
        await sweetalert({
          type: 'info',
          text: state.kanbo.locale.messages['DOCUMENT_RENAME_DUPLICATE']
            .replace('{name}', getFileName(name))
            .replace('{suggestedName}', getFileName(error.exception.SuggestedName)),
          confirmButtonText: state.kanbo.locale.messages['YES'],
          cancelButtonText: state.kanbo.locale.messages['NO'],
          showCancelButton: true,
        })

        return await dispatch(requestChangeDocumentName({
          ...payload,
          name: error.exception.SuggestedName
        }))
      } catch {}
    } else if (error.code === 537) {
      const state = getState()

      try {
        await sweetalert({
          type: 'info',
          text: state.kanbo.locale.messages['DOCUMENT_RENAME_INVALID_NAME']
          .replace('{name}', getFileName(name))
          .replace('{suggestedName}', getFileName(error.exception.SuggestedName)),
          confirmButtonText: state.kanbo.locale.messages['YES'],
          cancelButtonText: state.kanbo.locale.messages['NO'],
          showCancelButton: true,
        })

        return await dispatch(requestChangeDocumentName({
          ...payload,
          name: error.exception.SuggestedName
        }))
      } catch {}
    } else {
      throw error
    }
  }
}

export default requestChangeDocumentName